import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { DAY_VIDEO_REPORT_ID } from './dayVideoReportId';

const emptyColumns = [FIELDS.DATE].map(createFooterMapper(DAY_VIDEO_REPORT_ID));

const dayReportFooterColumnDefinition = [...emptyColumns];

export default dayReportFooterColumnDefinition;
